import { Autocomplete, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DefaultFornecedor } from "../../../../../../common/components/default_fornecedor_select";
import DefaultInput from "../../../../../../common/components/default_input";

type Props = {
  NDocumentoPesquisa: string;
  FornecedorPesquisa: number;
  centroDeCustoLista: { id: number; title: string }[];
  centroDeCusto: number[];
  StatusPesquisa: number;
  Documentos: number;
  Assinado: number;
  handleCentroDeCusto: (v: number[]) => void;
  onClearFilters: () => void;
  handleNDocumentoCampoChange: (value: string) => void;
  handleFornecedorChange: (v: number) => void;
  handleStatusPesquisa: (v: number) => void,
  handleDocumentos: (v: number) => void,
  handleAssinado: (v: number) => void,
};

export const Header = ({
  NDocumentoPesquisa,
  FornecedorPesquisa,
  StatusPesquisa,
  Documentos,
  Assinado,
  centroDeCusto,
  centroDeCustoLista,
  onClearFilters,
  handleNDocumentoCampoChange,
  handleCentroDeCusto,
  handleFornecedorChange,
  handleStatusPesquisa,
  handleDocumentos,
  handleAssinado,
}: Props) => {
  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 items-end">
        <div className="w-full col-span-2">
          <DefaultInput
            label="Nº Contrato"
            name='Nº Contrato'
            value={NDocumentoPesquisa}
            onChangeValue={e => handleNDocumentoCampoChange(e)}
          />
        </div>
        {/* Centro de Custo */}
        <FormControl size="small" fullWidth>
          <Autocomplete
            size="small"
            multiple
            options={centroDeCustoLista}
            value={centroDeCustoLista.filter((i) => centroDeCusto.includes(i.id))}
            getOptionLabel={(i) => i.title}
            onChange={(_, newValue) => {
              handleCentroDeCusto(newValue.map((i) => i.id));
            }}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            renderInput={(params) => (
              <TextField {...params} size="small" label="Centro de custo" />
            )}
          />
        </FormControl>

        {/* Fornecedor */}
        <div className="w-full">
          <DefaultFornecedor
            key={`forn-${FornecedorPesquisa}`}
            name="PesquisarFornecedor"
            value={FornecedorPesquisa || null}
            onChange={(valor) => handleFornecedorChange(Number(valor))}
            label="Fornecedor"
          />
        </div>

        {/* Status*/}
        <FormControl size="small" fullWidth>
          <InputLabel id="select-tempo-label" size="small">Status</InputLabel>
          <Select
            size="small"
            labelId="select-tempo-label"
            label="Status"
            value={StatusPesquisa}
            onChange={(event: SelectChangeEvent<number>) => {
              handleStatusPesquisa(event.target.value as number)
            }}
          >
            <MenuItem value={0}>Todos</MenuItem>
            <MenuItem value={1}>Em Andamento</MenuItem>
            <MenuItem value={2}>Paralisado</MenuItem>
            <MenuItem value={3}>Encerrado</MenuItem>
            <MenuItem value={4}>Vencido</MenuItem>
          </Select>
        </FormControl>

        {/* Documentos */}
        <FormControl size="small" fullWidth>
          <InputLabel id="select-dia-praticavel-label" size="small">Documentos</InputLabel>
          <Select
            size="small"
            labelId="select-dia-praticavel-label"
            label="Documentos"
            value={Documentos}
            onChange={(event: SelectChangeEvent<number>) => {
              handleDocumentos(event.target.value as number)
            }}
          >
            <MenuItem value={0}>Todos</MenuItem>
            <MenuItem value={1}>Vencido</MenuItem>
            <MenuItem value={2}>Em Dia</MenuItem>
          </Select>
        </FormControl>

        {/* Assinado */}
        <FormControl size="small" fullWidth>
          <InputLabel id="select-dia-praticavel-label" size="small">Assinado</InputLabel>
          <Select
            size="small"
            labelId="select-dia-praticavel-label"
            label="Assinado"
            value={Assinado}
            onChange={(event: SelectChangeEvent<number>) => {
              handleAssinado(event.target.value as number)
            }}
          >
            <MenuItem value={4}>Todos</MenuItem>
            <MenuItem value={0}>Assinado por todos</MenuItem>
            <MenuItem value={3}>Apenas a assinatura da empresa</MenuItem>
            <MenuItem value={1}>Não Assinado</MenuItem>
            <MenuItem value={2}>Não se Aplica</MenuItem>
          </Select>
        </FormControl>
        <div className="flex justify-end col-span-1 md:col-span-2 lg:col-span-3 xl:col-span-4 mt-2">
          <div className="w-full md:w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}
            >
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>

      </div>
    </CascateList>
  );
};